import makeApiRequest from './makeApiCall';
//sales
export const getLockTransactionModules = async () => {
  return await makeApiRequest(`/lock/modules`, 'POST', null);
};

export const getLockTransactions = async () => {
  return await makeApiRequest(`/lock/locking`, 'POST', null);
};

export const updateStatus = async (data) => {
  return await makeApiRequest(
    `/lock/modules/status/update`,
    'POST',
    null,
    data,
  );
};

export const updateDateLeadTime = async (data) => {
  return await makeApiRequest(`/lock/modules/date/update`, 'POST', null, data);
};

export const getAuditLockApproval = async (data) => {
  return await makeApiRequest(`/lock/request/approval`, 'POST', null, data);
};

export const getAuditLockApprovalByReference = async (data) => {
  return await makeApiRequest(`/lock/request/reference`, 'POST', null, data);
};

export const getAuditLockApprovedAndDisapproved = async (data) => {
  return await makeApiRequest(
    `lock/request/approval/update`,
    'POST',
    null,
    data,
  );
};

export const getAuditLockApprovalExport = async (data) => {
  return await makeApiRequest(
    `/lock/request/approval/export`,
    'POST',
    null,
    data,
  );
};
